/* eslint-disable camelcase */
import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { CannotAddDeletedSegmentsError } from "@lib/errors/FetchUserEncodedError";

export interface PatchCanvasStepProps<TData> {
  app_group_id: string;
  workflow_id: string;
  step_id: string;
  /**
   * @note this only applies to delay steps. It remains to be seen whether we want to
   *   have specific endpoints for each step type or have a polymorphic endpoint
   */
  step_data: TData;
}

type EnumerableError = CannotAddDeletedSegmentsError;

export const isEnumerableError = (error: FetchRequestError): error is EnumerableError => {
  return error instanceof FetchUserEncodedError;
};

export type PatchCanvasStepError = EnumerableError;
